module.exports = __webpack_public_path__ + "img/logoza-ru-hd.41643b65.png";